module.exports = {"title":"Forgot your username?","content":"To recover Username please speak with your organization's administrator or schedule a call with ShowTix4U Customer Service by clicking ","goBack":"Go back to the Login page"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotUsername/locales/en.json
// module id = 1758
// module chunks = 0